import React from 'react';
import './Hero.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import MagneticButton from './MagneticButton';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="hero-banner-wrapper">
      <div className="hero-banner">
        <div className="banner-bg" style={{ backgroundImage: 'url(/images/hero-banner-bg.jpg)' }}></div>
        <div className="banner-overlay"></div>
        <div className="hero-glow-effect"></div>
        <div className="banner-content">
          <div className="banner-title">
            <h1 className="banner-heading premium-text-white">
              {t.heroTitle}
            </h1>
            <p className="banner-subtitle">
              {t.heroSubtitle}
            </p>
          </div>
          <MagneticButton 
            as="a" 
            href="#contact-form" 
            className="banner-button magnetic"
          >
            {t.heroButton}
          </MagneticButton>
        </div>
      </div>
    </div>
  );
};

export default Hero;

